import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ProfessorPage } from '../pages/professor.page';

const ProfessorRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/professor' element={<ProfessorPage />} />
    </Routes>
  );
};

export { ProfessorRoutes };
